import React from 'react'
import Select from 'react-select'

const EditBrandsListItemSelect = ({sortedBrandsList, brandValue, onUpdateBrand}) => (
    <Select
        className="select-container"
        classNamePrefix="select"
        getOptionLabel={option => option.name}
        getOptionValue={option => option.pk}
        isClearable={true}
        options={sortedBrandsList}
        defaultValue={brandValue}
        value={brandValue}
        onChange={onUpdateBrand}
    />
)

export default EditBrandsListItemSelect